import { Card } from "antd";
import customStyles from "../../../../assets/styles/customStyles";
import clsx from 'clsx';

const FieldPrimaryCard = props => {
    const { title, component, customclasses, width } = props

    const classes = customStyles();
    return (
        <>
            <Card
                title={title}
                style={{ width: width ? width : 'auto' }}
                className={clsx(customclasses, classes.tableRoot)}
                {...props}>
                {component}
            </Card>
        </>
    )
}

export default FieldPrimaryCard